module.exports = __webpack_public_path__ + "img/24.1960cb09.jpg";